import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.scss';

const OutOfStock = ({ message, className, children }) => {
  const classes = classNames(styles.outOfStock, className);

  return (
    <div className={classes}>
      <span>{message}</span>
      {children}
    </div>
  );
};

OutOfStock.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default OutOfStock;
